export const home = {
  // Hero Section
  heroTitle: 'حلول ألياف الصلب المتفوقة',
  heroSubtitle: 'مصممة للقوة، مصممة للمتانة. تقدم ألياف الصلب DYNAMIX ذات النهاية المعقوفة أداءً استثنائياً في تعزيز الخرسانة لمشاريع البنية التحتية الحرجة.',

  // Features
  featuresTitle: 'لماذا تختار ألياف الصلب DYNAMIX',
  featuresSubtitle: 'الهندسة المتقدمة تلتقي بالأداء المتفوق',

  feature1Title: 'قوة شد متفوقة',
  feature1Desc: 'الصلب عالي الجودة بقوة شد 1000-1200 ميجا باسكال يضمن أقصى قدرة على تحمل الأحمال وسلامة الهيكل.',

  feature2Title: 'تصميم النهاية المعقوفة المحسّن',
  feature2Desc: 'هندسة الخطاف المصممة توفر تثبيتاً استثنائياً في مصفوفة الخرسانة، مما يمنع سحب الألياف تحت الضغط.',

  feature3Title: 'تحكم محسّن في التشققات',
  feature3Desc: 'توزيع الألياف الموحد ينشئ شبكة تعزيز ثلاثية الأبعاد تتحكم بفعالية في انتشار التشققات.',

  feature4Title: 'مقاوم للتآكل',
  feature4Desc: 'تركيبة الصلب المميزة مع الطلاء الواقي تضمن متانة طويلة الأمد في الظروف البيئية القاسية.',

  feature5Title: 'سهولة التطبيق',
  feature5Desc: 'الألياف ذات التدفق الحر تختلط بسهولة مع الخرسانة، مما يضمن التوزيع الموحد دون تكدس أو تجمع.',

  feature6Title: 'اقتصادي',
  feature6Desc: 'يقلل من تكاليف العمالة ووقت البناء مع القضاء على الحاجة إلى تعزيز الشبكة التقليدية.',

  // Applications Preview
  applicationsTitle: 'التطبيقات المثبتة',
  applicationsSubtitle: 'موثوق في مشاريع البنية التحتية الحرجة في جميع أنحاء العالم',

  app1Title: 'الأرضيات الصناعية',
  app1Desc: 'المستودعات عالية الحركة ومرافق التصنيع',

  app2Title: 'بطانة الأنفاق',
  app2Desc: 'البنية التحتية تحت الأرض وعمليات التعدين',

  app3Title: 'السدود والمنشآت المائية',
  app3Desc: 'مشاريع البنية التحتية المائية الكبيرة والطاقة الكهرومائية',

  app4Title: 'العناصر مسبقة الصب',
  app4Desc: 'مكونات الخرسانة مسبقة الصب المعمارية والهيكلية',

  viewAllApplications: 'عرض جميع التطبيقات',

  // Technical Excellence
  technicalTitle: 'التميز التقني',
  technicalSubtitle: 'مصنعة وفقاً لأعلى المعايير الدولية',

  tech1Title: 'معتمد ASTM A820',
  tech1Desc: 'يلبي جميع متطلبات معيار ASTM A820 لألياف الصلب المستخدمة في الخرسانة المعززة بالألياف.',

  tech2Title: 'جودة ISO 9001',
  tech2Desc: 'مصنعة تحت نظام إدارة الجودة الصارم ISO 9001 الذي يضمن جودة المنتج المتسقة.',

  tech3Title: 'اختبارات متقدمة',
  tech3Desc: 'كل دفعة تخضع لاختبارات صارمة لقوة الشد والهندسة وخصائص الأداء.',

  tech4Title: 'الدعم التقني',
  tech4Desc: 'دعم هندسي خبير لتصميم الخلطة وحساب الجرعة وإرشادات التطبيق.',

  // CTA
  ctaTitle: 'هل أنت مستعد لتقوية مشروعك؟',
  ctaSubtitle: 'احصل على استشارة خبيرة ودعم تقني لاحتياجات تعزيز الخرسانة الخاصة بك.',
  getInTouch: 'تواصل معنا',
};

